(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (!configuratorRoot || configuratorRoot.configuratorLayouts) return;

  var ARTWORK_WIDTH = 1680;
  var ARTWORK_HEIGHT = 160;
  var SAFE_AREA = { x: 54, y: 29, width: 1572, height: 102 };
  var PHYSICAL_SIZE = { widthInches: 10.5, heightInches: 1, widthCentimeters: 26.8, heightCentimeters: 2.8 };
  var MODULE_ORDER = ['logo', 'restaurantName', 'restaurantInfo', 'message', 'additionalText'];
  var BLOCK_DEFINITIONS = {
    logo: { kind: 'logo', role: 'brand', weight: 1.35 },
    restaurantName: { kind: 'text', role: 'title', weight: 1.15 },
    restaurantInfo: { kind: 'text', role: 'details', weight: 1 },
    message: { kind: 'text', role: 'message', weight: 1.15 },
    additionalText: { kind: 'text', role: 'additional', weight: .85 }
  };

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function enabledModules(configuration) {
    return MODULE_ORDER.filter(function (moduleId) {
      return configuration.content.enabledTypes.indexOf(moduleId) !== -1;
    });
  }

  function semanticPayload(configuration) {
    var values = configuration.content.values;
    return enabledModules(configuration).map(function (moduleId) {
      if (moduleId === 'logo') {
        return { module: moduleId, assetId: configuration.logo && configuration.logo.assetId };
      }
      if (moduleId === 'restaurantInfo') {
        return {
          module: moduleId,
          address: values.restaurantInfo.address.trim(),
          phone: values.restaurantInfo.phone.trim(),
          contact: values.restaurantInfo.contact.trim()
        };
      }
      return { module: moduleId, value: String(values[moduleId] || '').trim() };
    });
  }

  function hashString(value) {
    var hash = 2166136261;
    for (var index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return ('00000000' + (hash >>> 0).toString(16)).slice(-8);
  }

  function getFingerprint(configuration) {
    return 'content-v1-' + hashString(JSON.stringify(semanticPayload(configuration)));
  }

  function createBlock(moduleId, instance) {
    var definition = BLOCK_DEFINITIONS[moduleId];
    return {
      id: moduleId + '-' + instance,
      module: moduleId,
      kind: definition.kind,
      role: definition.role,
      weight: definition.weight
    };
  }

  function createBlocks(moduleIds, sideId) {
    return moduleIds.map(function (moduleId, index) {
      return createBlock(moduleId, sideId + '-' + index);
    });
  }

  function createSide(moduleIds, flow, alignment, sideId) {
    return {
      flow: flow || 'stack',
      alignment: alignment || 'center',
      blocks: createBlocks(moduleIds, sideId)
    };
  }

  function createComposition(layoutId, fingerprint, front, back) {
    return {
      version: 1,
      layoutId: layoutId,
      sourceFingerprint: fingerprint,
      sides: {
        front: front,
        back: back
      }
    };
  }

  function brandForwardCandidate(active, fingerprint) {
    var brand = active.filter(function (moduleId) { return moduleId === 'logo' || moduleId === 'restaurantName'; });
    var remaining = active.filter(function (moduleId) { return brand.indexOf(moduleId) === -1; });
    var frontModules = brand.length ? brand : active.slice(0, 1);
    var backModules = brand.length ? remaining : active.slice(1);
    return {
      id: 'brand-forward',
      label: brand.length ? 'Brand forward' : 'Clear focus',
      description: backModules.length ? 'A focused front with supporting content on the reverse.' : 'A confident single-sided presentation.',
      composition: createComposition(
        'brand-forward',
        fingerprint,
        createSide(frontModules, frontModules.length > 1 ? 'row' : 'stack', 'center', 'front'),
        createSide(backModules, 'stack', 'center', 'back')
      )
    };
  }

  function balancedCandidate(active, fingerprint) {
    var frontModules = [];
    var backModules = [];
    var frontFlow = 'stack';

    if (active.length === 1) {
      frontModules = active.slice();
      backModules = active.slice();
    } else if (active.length === 2 && active.indexOf('logo') !== -1 && active.indexOf('restaurantName') !== -1) {
      frontModules = ['logo'];
      backModules = ['restaurantName'];
    } else if (active.length === 2) {
      frontModules = active.slice();
      frontFlow = 'row';
    } else {
      active.forEach(function (moduleId, index) {
        (index % 2 ? backModules : frontModules).push(moduleId);
      });
    }

    return {
      id: 'balanced',
      label: active.length === 2 && !backModules.length ? 'Together' : 'Balanced sides',
      description: backModules.length ? 'Content is distributed evenly across both sides.' : 'The selected content works together on one side.',
      composition: createComposition(
        'balanced',
        fingerprint,
        createSide(frontModules, frontFlow, 'center', 'front'),
        createSide(backModules, 'stack', 'center', 'back')
      )
    };
  }

  function alternateFocusCandidate(active, fingerprint) {
    var narrative = active.filter(function (moduleId) { return moduleId === 'message' || moduleId === 'additionalText'; });
    var information = active.filter(function (moduleId) { return moduleId === 'restaurantInfo'; });
    var frontModules;
    var backModules;
    var label;

    if (active.length === 1) {
      frontModules = active.slice();
      backModules = [];
      label = 'Editorial edge';
    } else if (narrative.length) {
      frontModules = narrative;
      backModules = active.filter(function (moduleId) { return narrative.indexOf(moduleId) === -1; });
      label = 'Message first';
    } else if (information.length) {
      frontModules = information;
      backModules = active.filter(function (moduleId) { return information.indexOf(moduleId) === -1; });
      label = 'Information first';
    } else {
      frontModules = active.slice(1).reverse();
      backModules = active.slice(0, 1);
      label = 'Two-sided brand';
    }

    return {
      id: 'alternate-focus',
      label: label,
      description: active.length === 1 ? 'A restrained, left-aligned single-sided treatment.' : 'The supporting story leads, with the brand carried on the reverse.',
      composition: createComposition(
        'alternate-focus',
        fingerprint,
        createSide(frontModules, frontModules.length > 1 ? 'row' : 'stack', 'left', 'front'),
        createSide(backModules, backModules.length > 1 ? 'row' : 'stack', 'right', 'back')
      )
    };
  }

  function compositionSignature(composition) {
    return JSON.stringify({
      front: {
        flow: composition.sides.front.flow,
        alignment: composition.sides.front.alignment,
        modules: composition.sides.front.blocks.map(function (block) { return block.module; })
      },
      back: {
        flow: composition.sides.back.flow,
        alignment: composition.sides.back.alignment,
        modules: composition.sides.back.blocks.map(function (block) { return block.module; })
      }
    });
  }

  function generate(configuration) {
    var active = enabledModules(configuration);
    var fingerprint = getFingerprint(configuration);
    if (!active.length) return [];

    var candidates = [
      brandForwardCandidate(active, fingerprint),
      balancedCandidate(active, fingerprint),
      alternateFocusCandidate(active, fingerprint)
    ];
    var signatures = {};
    return candidates.filter(function (candidate) {
      var signature = compositionSignature(candidate.composition);
      if (signatures[signature]) return false;
      signatures[signature] = true;
      return validateComposition(candidate.composition, configuration);
    });
  }

  function isValidSide(side) {
    if (!side || (side.flow !== 'row' && side.flow !== 'stack')) return false;
    if (['left', 'center', 'right'].indexOf(side.alignment) === -1 || !Array.isArray(side.blocks)) return false;
    return side.blocks.every(function (block) {
      return Boolean(
        block &&
        typeof block.id === 'string' &&
        MODULE_ORDER.indexOf(block.module) !== -1 &&
        (block.kind === 'logo' || block.kind === 'text') &&
        typeof block.role === 'string' &&
        typeof block.weight === 'number' && block.weight > 0
      );
    });
  }

  function validateComposition(composition, configuration) {
    if (!isCompositionStructure(composition)) return false;
    if (composition.sourceFingerprint !== getFingerprint(configuration)) return false;

    var active = enabledModules(configuration);
    var represented = composition.sides.front.blocks.concat(composition.sides.back.blocks).map(function (block) { return block.module; });
    return active.every(function (moduleId) { return represented.indexOf(moduleId) !== -1; }) &&
      represented.every(function (moduleId) { return active.indexOf(moduleId) !== -1; });
  }

  function isCompositionStructure(composition) {
    return Boolean(
      composition &&
      composition.version === 1 &&
      typeof composition.layoutId === 'string' && composition.layoutId.length > 0 &&
      typeof composition.sourceFingerprint === 'string' && composition.sourceFingerprint.length > 0 &&
      composition.sides &&
      isValidSide(composition.sides.front) &&
      isValidSide(composition.sides.back)
    );
  }

  function createArtworkCanvas() {
    var canvas = document.createElement('canvas');
    canvas.width = ARTWORK_WIDTH;
    canvas.height = ARTWORK_HEIGHT;
    return canvas;
  }

  function drawArtworkBase(canvas, background) {
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = background.fill;
    context.fillRect(0, 0, canvas.width, canvas.height);
  }

  function fontForStyle(style, size) {
    var parts = [];
    if (style.fontStyle === 'italic') parts.push('italic');
    if (style.fontWeight !== 400) parts.push(String(style.fontWeight));
    parts.push(size + 'px');
    parts.push(style.fontFamily);
    return parts.join(' ');
  }

  function breakLongWord(context, word, maximumWidth) {
    var parts = [];
    var part = '';
    word.split('').forEach(function (character) {
      var next = part + character;
      if (part && context.measureText(next).width > maximumWidth) {
        parts.push(part);
        part = character;
      } else {
        part = next;
      }
    });
    if (part) parts.push(part);
    return parts;
  }

  function textLineWidth(context, line, style) {
    var spacing = (style.letterSpacing || 0) * ARTWORK_HEIGHT;
    return context.measureText(line).width + Math.max(0, line.length - 1) * spacing;
  }

  function wrapText(context, text, maximumWidth, style) {
    if (style.wrap === 'none') return String(text).split('\n');
    var lines = [];
    String(text).split('\n').forEach(function (paragraph) {
      var line = '';
      paragraph.split(/\s+/).filter(Boolean).forEach(function (word) {
        var words = context.measureText(word).width > maximumWidth ? breakLongWord(context, word, maximumWidth) : [word];
        words.forEach(function (part) {
          var candidate = line ? line + ' ' + part : part;
          if (line && textLineWidth(context, candidate, style) > maximumWidth) {
            lines.push(line);
            line = part;
          } else {
            line = candidate;
          }
        });
      });
      lines.push(line);
    });
    return lines.length ? lines : [''];
  }

  function fitText(context, text, rectangle, style) {
    var maximum = style.fontSize * ARTWORK_HEIGHT;
    var minimum = style.fit === 'fixed' ? Math.floor(maximum) : 4;
    var horizontalPadding = style.paddingX * ARTWORK_WIDTH;
    var verticalPadding = style.paddingY * ARTWORK_HEIGHT;
    var result = null;
    for (var size = Math.floor(maximum); size >= minimum; size -= 1) {
      context.font = fontForStyle(style, size);
      var lines = wrapText(context, text, rectangle.width - horizontalPadding * 2, style);
      var lineHeight = size * style.lineHeight;
      result = { size: size, lines: lines, lineHeight: lineHeight };
      if (lines.length * lineHeight <= rectangle.height - verticalPadding * 2 || style.fit === 'fixed') break;
    }
    return result;
  }

  function measureTextObject(object) {
    var context = createArtworkCanvas().getContext('2d');
    var rectangle = frameRectangle(object.frame);
    var fitted = fitText(context, object.text, rectangle, object.style);
    context.font = fontForStyle(object.style, fitted.size);
    var widestLine = fitted.lines.reduce(function (width, line) {
      return Math.max(width, textLineWidth(context, line, object.style));
    }, 0);
    var paddingX = object.style.paddingX * ARTWORK_WIDTH;
    var paddingY = object.style.paddingY * ARTWORK_HEIGHT;
    return {
      rectangle: rectangle,
      size: fitted.size,
      lines: fitted.lines.slice(),
      lineHeight: fitted.lineHeight,
      textWidth: widestLine,
      textHeight: fitted.lines.length * fitted.lineHeight,
      interactionWidth: Math.min(rectangle.width, Math.max(18, widestLine + Math.max(6, paddingX * 2))),
      interactionHeight: Math.min(rectangle.height, Math.max(12, fitted.lines.length * fitted.lineHeight + Math.max(4, paddingY * 2)))
    };
  }

  function frameRectangle(frame) {
    return {
      x: frame.x * ARTWORK_WIDTH,
      y: frame.y * ARTWORK_HEIGHT,
      width: frame.width * ARTWORK_WIDTH,
      height: frame.height * ARTWORK_HEIGHT
    };
  }

  function beginObjectTransform(context, rectangle, rotation) {
    if (!rotation) return;
    var centerX = rectangle.x + rectangle.width / 2;
    var centerY = rectangle.y + rectangle.height / 2;
    context.translate(centerX, centerY);
    context.rotate(rotation * Math.PI / 180);
    context.translate(-centerX, -centerY);
  }

  function drawTextObject(context, object, diagnostics) {
    var rectangle = frameRectangle(object.frame);
    var style = object.style;
    var horizontalPadding = style.paddingX * ARTWORK_WIDTH;
    var measurement = measureTextObject(object);
    var fitted = { size: measurement.size, lines: measurement.lines, lineHeight: measurement.lineHeight };
    var totalHeight = fitted.lines.length * fitted.lineHeight;
    var y = rectangle.y + (rectangle.height - totalHeight) / 2 + fitted.lineHeight * .78;
    var x = rectangle.x + (style.align === 'left' ? horizontalPadding : style.align === 'right' ? rectangle.width - horizontalPadding : rectangle.width / 2);

    context.save();
    beginObjectTransform(context, rectangle, object.rotation);
    context.beginPath();
    context.rect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    context.clip();
    context.fillStyle = style.fill;
    context.font = fontForStyle(style, fitted.size);
    context.textAlign = style.align;
    context.textBaseline = 'alphabetic';
    fitted.lines.forEach(function (line) {
      var spacing = (style.letterSpacing || 0) * ARTWORK_HEIGHT;
      if (!spacing || line.length < 2) {
        context.fillText(line, x, y);
      } else {
        var lineWidth = textLineWidth(context, line, style);
        var cursor = style.align === 'center' ? x - lineWidth / 2 : style.align === 'right' ? x - lineWidth : x;
        context.textAlign = 'left';
        line.split('').forEach(function (character) {
          context.fillText(character, cursor, y);
          cursor += context.measureText(character).width + spacing;
        });
        context.textAlign = style.align;
      }
      y += fitted.lineHeight;
    });
    var widestLine = measurement.textWidth;
    context.restore();

    diagnostics.minimumFontSize = Math.min(diagnostics.minimumFontSize, fitted.size);
    if (totalHeight > rectangle.height || widestLine > rectangle.width - horizontalPadding * 2) diagnostics.overflow = true;
  }

  function drawImageObject(context, object, image) {
    if (!image) return;
    var rectangle = frameRectangle(object.frame);
    var contentFrame = object.style.contentFrame;
    var x;
    var y;
    var width;
    var height;
    if (contentFrame) {
      x = rectangle.x + rectangle.width * contentFrame.x;
      y = rectangle.y + rectangle.height * contentFrame.y;
      width = rectangle.width * contentFrame.width;
      height = rectangle.height * contentFrame.height;
    } else {
      var padding = Math.min(10, rectangle.height * object.style.padding);
      var maximumWidth = rectangle.width - padding * 2;
      var maximumHeight = rectangle.height - padding * 2;
      var naturalWidth = image.naturalWidth || image.width;
      var naturalHeight = image.naturalHeight || image.height;
      var scale = object.style.fit === 'cover'
        ? Math.max(maximumWidth / naturalWidth, maximumHeight / naturalHeight)
        : Math.min(maximumWidth / naturalWidth, maximumHeight / naturalHeight);
      width = object.style.fit === 'fill' ? maximumWidth : naturalWidth * scale;
      height = object.style.fit === 'fill' ? maximumHeight : naturalHeight * scale;
      x = rectangle.x + (rectangle.width - width) / 2;
      if (object.style.align === 'left') x = rectangle.x + padding;
      if (object.style.align === 'right') x = rectangle.x + rectangle.width - padding - width;
      y = rectangle.y + (rectangle.height - height) / 2;
    }

    context.save();
    beginObjectTransform(context, rectangle, object.rotation);
    context.globalAlpha = object.style.opacity;
    context.beginPath();
    context.rect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    context.clip();
    context.drawImage(image, x, y, width, height);
    context.restore();
  }

  function getBlockRectangles(side) {
    if (!side.blocks.length) return [];
    var gap = side.flow === 'row' ? 24 : 5;
    var available = (side.flow === 'row' ? SAFE_AREA.width : SAFE_AREA.height) - gap * (side.blocks.length - 1);
    var totalWeight = side.blocks.reduce(function (total, block) { return total + block.weight; }, 0);
    var cursor = side.flow === 'row' ? SAFE_AREA.x : SAFE_AREA.y;

    return side.blocks.map(function (block, index) {
      var extent = index === side.blocks.length - 1
        ? (side.flow === 'row' ? SAFE_AREA.x + SAFE_AREA.width : SAFE_AREA.y + SAFE_AREA.height) - cursor
        : available * block.weight / totalWeight;
      var rectangle = side.flow === 'row'
        ? { x: cursor, y: SAFE_AREA.y, width: extent, height: SAFE_AREA.height }
        : { x: SAFE_AREA.x, y: cursor, width: SAFE_AREA.width, height: extent };
      cursor += extent + gap;
      return rectangle;
    });
  }

  function drawSide(canvas, side, images, diagnostics) {
    drawArtworkBase(canvas, side.background);
    var context = canvas.getContext('2d');
    side.objects.forEach(function (object) {
      if (object.type === 'image') drawImageObject(context, object, images[object.asset.id]);
      else drawTextObject(context, object, diagnostics);
    });
  }

  function loadImage(asset) {
    if (asset && asset.element) return Promise.resolve({ id: asset.id, image: asset.element, objectUrl: null });
    if (!asset || !asset.blob) return Promise.reject(new Error('The design asset is unavailable.'));
    return new Promise(function (resolve, reject) {
      var objectUrl = URL.createObjectURL(asset.blob);
      var image = new Image();
      image.decoding = 'async';
      image.onload = function () { resolve({ id: asset.id, image: image, objectUrl: objectUrl }); };
      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('The design asset could not be rendered.'));
      };
      image.src = objectUrl;
    });
  }

  function collectAssets(resolvedDocument) {
    var assets = {};
    resolvedDocument.sides.front.objects.concat(resolvedDocument.sides.back.objects).forEach(function (object) {
      if (object.type === 'image') assets[object.asset.id] = object.asset;
    });
    return assets;
  }

  function renderResolvedDocument(resolvedDocument) {
    var front = createArtworkCanvas();
    var back = createArtworkCanvas();
    var diagnostics = { overflow: false, minimumFontSize: 999 };
    var assets = collectAssets(resolvedDocument);
    var loading = Object.keys(assets).map(function (assetId) { return loadImage(assets[assetId]); });

    return Promise.all(loading).then(function (loaded) {
      var images = {};
      loaded.forEach(function (item) { images[item.id] = item.image; });
      try {
        drawSide(front, resolvedDocument.sides.front, images, diagnostics);
        drawSide(back, resolvedDocument.sides.back, images, diagnostics);
      } finally {
        loaded.forEach(function (item) { if (item.objectUrl) URL.revokeObjectURL(item.objectUrl); });
      }
      if (diagnostics.minimumFontSize === 999) diagnostics.minimumFontSize = null;
      return { front: front, back: back, diagnostics: diagnostics };
    });
  }

  configuratorRoot.configuratorLayouts = {
    artworkSize: { width: ARTWORK_WIDTH, height: ARTWORK_HEIGHT },
    safeArea: clone(SAFE_AREA),
    physicalSize: clone(PHYSICAL_SIZE),
    moduleOrder: MODULE_ORDER.slice(),
    getFingerprint: getFingerprint,
    generate: generate,
    isCompositionStructure: isCompositionStructure,
    validateComposition: validateComposition,
    getBlockRectangles: function (side) { return clone(getBlockRectangles(side)); },
    measureTextObject: measureTextObject,
    renderResolvedDocument: renderResolvedDocument
  };
}());
